import { useNavigate } from "react-router";

import { Grid2, IconButton, Stack, Tooltip, Typography } from "@mui/material";
import { IconArrowLeft, IconInfoSquareRounded } from "@tabler/icons-react";

const PageHeader = ({
  title = "",
  subtitle = "",
  back = false,
  options = false,
  padding = 0,
  backRouter,
  sticky = false,
  tooltip = "",
}: any) => {
  const n = useNavigate();

  return (
    <Grid2
      width="100%"
      container
      spacing={2}
      mb={2}
      alignItems="center"
      sx={
        sticky
          ? {
              position: "sticky",
              top: 0,
              zIndex: 1000,
              backgroundColor: "secondary.light", // ou um valor fixo como "#fff"
              borderBottom: "1px solid",
              borderColor: "divider",
              py: 1,
            }
          : {}
      }
    >
      <Grid2 size={{ xs: 12, md: 6 }} padding={padding}>
        <Stack sx={{ flexDirection: "row", alignItems: "center", gap: 1 }}>
          {back && (
            <IconButton
              onClick={() => {
                if (backRouter) {
                  n(backRouter);
                  return;
                }

                n(-1);
              }}
            >
              <IconArrowLeft />
            </IconButton>
          )}
          <Stack>
            <Stack direction="row" alignItems="center" spacing={1} mb={0.5}>
              <Typography variant="h1" fontWeight={600} fontSize={26}>
                {title}
              </Typography>
              {tooltip && (
                <Tooltip title={tooltip}>
                  <IconButton
                    size="small"
                    sx={{
                      padding: 0,
                      cursor: "pointer",
                      color: "#9c27b0",
                    }}
                  >
                    <IconInfoSquareRounded />
                  </IconButton>
                </Tooltip>
              )}
            </Stack>

            <Typography variant="subtitle1" color="secondary.contrastText">
              {subtitle}
            </Typography>
          </Stack>
        </Stack>
      </Grid2>
      <Grid2 size={{ xs: 12, md: 6 }}>{options && options}</Grid2>
    </Grid2>
  );
};

export default PageHeader;
